import gsap from "gsap"
import { useLayoutEffect, useRef } from "react"
import { ScrollTrigger } from "gsap/all"
import { useGSAP } from "@gsap/react"
import BaseOutlineText from "../../../components/general/BaseOutlineText"

export default function HelloFilmAnimation() {
    const textRef = useRef(null)
    const videoContainerRefStart = useRef<HTMLDivElement | null>(null)
    const imageFilmRef = useRef<HTMLDivElement | null>(null)
    useLayoutEffect(() => {
        if (window.innerWidth > 768) {
            const ctx = gsap.context((self) => {
                ScrollTrigger.create({
                    trigger: videoContainerRefStart.current,
                    pin: true,
                    start: "top 12%",
                    end: "+=1300",
                    pinSpacing: false,
                    invalidateOnRefresh: true,
                    refreshPriority: 2,
                })
            })
            return () => ctx.revert()
        }
    }, [])


    useGSAP(
        () => {
            const mm = gsap.matchMedia()

            mm.add("(min-width: 768px)", () => {
                const imageFilm = gsap.timeline({
                    scrollTrigger: {
                        trigger: imageFilmRef.current,
                        start: "top center",
                        end: "bottom top",
                        scrub: true,
                        invalidateOnRefresh: true,
                        refreshPriority: 2,
                    },
                })

                // Images
                imageFilm.to(imageFilmRef.current, {
                    width: "102vw",
                    height: "102vh",
                    bottom: 0,
                    left: 0,
                    ease: "ease2.out",
                })

                // Text reveal
                gsap.fromTo(
                    textRef.current,
                    { clipPath: "inset(100% 0% 0% 0%)" },
                    {
                        clipPath: "inset(0% 0% 0% 0%)",
                        duration: 1,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: textRef.current,
                            start: "top 80%",
                            toggleActions: "play play play play",
                        },
                    }
                )
            })

            return () => mm.revert()
        },
        { scope: videoContainerRefStart }
    )

    return (
        <section
            ref={videoContainerRefStart}
            className="w-screen mt-32 md:mt-0 h-fit md:h-[90vh] flex justify-start xl:justify-center md:items-end md:wrapperClass relative pb-24 md:pb-0">
            <div ref={imageFilmRef} className="w-full md:w-[54vw] imageFilm md:h-[60vh] object-cover md:bottom-[12vh] md:left-[16vw] xl:left-auto md:absolute z-30">
                <BaseOutlineText
                    weight={"medium"}
                    text="Wicode"
                    textSize="text-6xl md:text-[10rem]"
                    classProps="absolute opacity-30 md:opacity-100 -top-4 md:top-48 md:-right-96 md:rotate-90 -z-20"
                />
                <video
                    className="object-cover w-full h-80 md:h-full"
                    autoPlay
                    loop
                    muted
                    playsInline
                    webkit-playsinline
                    preload="auto"
                    poster="/assets/poster.jpg">
                    <source src={"/assets/wicode_image_film_lowres.mp4"} type="video/mp4" />
                    <source src={"/assets/wicode_image_film_v3.webm"} type="video/webm" />
                    Your Browser does not support the video tag.
                </video>
            </div>
        </section>
    )
}
